import { Firebase, FirebaseRef } from '../lib/firebase'
import { FETCH_APP_CHANGE } from '../constants/app'
import store from '../store'

export function createApp(formData) {
  if (Firebase === null) return () => new Promise(resolve => resolve())

  return new Promise(resolve => {
    const Ref = FirebaseRef.push()
    const key = Ref.getKey()

    return FirebaseRef.child(`app/${key}`)
      .set({
        ...formData
      })
      .then(() => {

        return resolve({ isSuccess: true, key })
      })
      .catch(err => {
        return resolve({ isSuccess: false, err })
      })
  })
}

export function getApp(id) {
  return new Promise(resolve => {
    const ref = FirebaseRef.child(`app/${id}`)

    ref.on('value', snapshot => {
      const data = snapshot.val() || {}

      return resolve({ isSuccess: true, data })
    })
  })
}

export function getAppMutiple(limit = 200, type, value) {
  return new Promise(resolve => {
    let ref = FirebaseRef.child('app')
    if (type && value) {
      ref = ref.orderByChild(type).startAt(value).endAt(value + '\uf8ff')
    }
    if (limit) {
      ref = ref.limitToLast(limit)
    }
    let newData = []
    ref.on('value', snapshot => {
      const data = snapshot.val()

      if (data && typeof (data) === 'object') {
        Object.keys(data).forEach(key => {
          newData.push({
            id: key,
            ...data[key]
          })
        })
        const newArray = newData.reverse()
        return resolve({ isSuccess: true, data: newArray })
      }
      else {
        return resolve({ isSuccess: false, data })
      }

    })

  })
}

export function updateApp(id, formData) {
  return new Promise(resolve => {

    const ref = FirebaseRef.child(`app/${id}`)

    return ref
      .set({
        ...formData
      })
      .then(() => {
        return resolve({ isSuccess: true })
      })
      .catch(err => {
        return resolve({ isSuccess: false, err })
      })

  })
}

export async function uploadMutipleFile(ImageFile, path = 'path_file/', type = "image/jpeg") {
  const storage = Firebase.storage()
  const storageRef = storage.ref()

  const metadata = {
    contentType: type
  }

  let result = {}
  let uid = (
    FirebaseRef
    && Firebase
    && Firebase.auth()
    && Firebase.auth().currentUser
    && Firebase.auth().currentUser.uid
  ) ? Firebase.auth().currentUser.uid : null

  await storageRef
    .child(uid + '/' + path + ImageFile.name)
    .put(ImageFile, metadata)
    .then(uploadTask => {
      return uploadTask.ref.getDownloadURL().then(url => {
        result = {}
        result['isSuccess'] = true
        result['url'] = url

        return result
      }).catch(err => {
        console.log(err)
        return { isSuccess: false, err }
      })
    }).catch(err => {
      console.log(err)
      return { isSuccess: false, err }
    })

  return result
}

export function removeApp(id) {
  return new Promise(resolve => {
    const ref = FirebaseRef.child(`app/${id}`)

    ref.remove().then((result) => {

      return resolve({ isSuccess: true })
    }).catch(err => {
      return resolve({ isSuccess: false, err })
    })
  })
}

export function handleChangeApp(data) {
  store.dispatch({
    type: FETCH_APP_CHANGE,
    payload: data
  })
}